var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C8.02218 0.5 6.08876 1.08647 4.44427 2.18528C2.79978 3.2841 1.51808 4.84589 0.761204 6.67315C0.00432813 8.50041 -0.193699 10.5111 0.192153 12.4509C0.578006 14.3907 1.53039 16.1726 2.92892 17.5711C4.32744 18.9696 6.1093 19.922 8.04911 20.3078C9.98892 20.6937 11.9996 20.4957 13.8268 19.7388C15.6541 18.9819 17.2159 17.7002 18.3147 16.0557C19.4135 14.4112 20 12.4778 20 10.5C20 7.84784 18.9464 5.30429 17.0711 3.42892C15.1957 1.55356 12.6522 0.5 10 0.5ZM13.9834 15.05C13.6718 15.3417 13.2602 15.5028 12.8333 15.5C12.606 15.5014 12.3808 15.4563 12.1716 15.3675C11.9623 15.2786 11.7735 15.1479 11.6167 14.9833L8.78331 11.9834C8.49159 11.6718 8.33054 11.2602 8.33333 10.8334V5.83335C8.33333 5.39133 8.50895 4.96738 8.82151 4.65482C9.13407 4.34226 9.55797 4.16669 10 4.16669C10.442 4.16669 10.8659 4.34226 11.1785 4.65482C11.491 4.96738 11.6667 5.39133 11.6667 5.83335V10.1666L14.05 12.6833C14.2019 12.8426 14.3208 13.0305 14.3997 13.236C14.4787 13.4414 14.5161 13.6605 14.5099 13.8806C14.5037 14.1006 14.454 14.3172 14.3636 14.5179C14.2732 14.7187 14.144 14.8995 13.9834 15.05Z",
    fill: "#D9E6F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.1531eb75b77ab30c9105791c697bf07f.svg";
export { ForwardRef as ReactComponent };